<script lang="ts" setup>
import { useFormField } from '../hooks/useFormField';
import type { IFormDescriptionProps } from '../types/FormDescription';

const props = defineProps<IFormDescriptionProps>();

const { formDescriptionId } = useFormField();
</script>

<template>
  <div :id="formDescriptionId" data-slot="form-description">
    <slot />
  </div>
</template>
